// reducers/messageReducer.js

import { initialDataQuotation, initialErrorsQuotation } from "Data/quotation";

export const initialMessageState = {
    messageLoading: true,
    //Tab Control
    activeTab: 'direct-messages',
    //direct chat contect list
    directContact: [],
    dcLoading: true,
    dcPageIndex: 1,
    dcSummary: {},
    dcError: '',

    //Quotation contact list
    quotationContact: [],
    qcLoading: true,
    qcPageIndex: 1,
    qcSummary: {},
    qcError: '',

    //DC/QC Active User
    activeUser: {},
    //DC/QC Active user Messages
    msg: [],
    msgLoading: true,
    msgPageIndex: 1,
    initialPageIndex: 1,
    newMessageAdded: false,
    oneMessageAdded: false,
    msgSummary: {},
    msgError: '',
    quotationFormToggle: false,
    operatorParksOptions: [],
    //for Quation Form
    formData: {},
    errors: {},
    //for mobile Screen
    toggleChatContact: false,


};

export const messageReducer = (state = initialMessageState, action) => {
    switch (action.type) {
        case "SET_MESSAGE_LOADING":
            return {
                ...state,
                messageLoading: typeof action.payload === "boolean" ? action.payload : state.messageLoading,
            };
        case "SET_ACTIVE_TAB_MESSAGE":
            return {
                ...state,
                activeTab: typeof action.payload === "string" ? action.payload : state.activeTab,
            };
        // For Direct Contact     
        case "DC_CONTACT_LOADING":
            return {
                ...state,
                dcLoading: typeof action.payload === "boolean" ? action.payload : state.dcLoading,
            };
        case 'SET_DIRECT_CONTACT_DATA':
            return {
                ...state,
                directContact: Array.isArray(action.payload)
                    ? action.payload
                    : state.directContact,
            };

        case 'APPEND_DIRECT_CONTACT_DATA':
            const existingIds = new Set(state.directContact.map(p => p.id));
            const newUniqueParks = action.payload.filter(p => !existingIds.has(p.id));

            return {
                ...state,
                directContact: [...state.directContact, ...newUniqueParks],
            };
        case 'DC_SUMMARY':
            return {
                ...state,
                dcSummary: action.payload && typeof action.payload === 'object'
                    ? action.payload
                    : state.dcSummary,
            };

        case 'DC_PAGE_INDEX':
            return {
                ...state,
                dcPageIndex: typeof action.payload === 'number' && !isNaN(action.payload)
                    ? action.payload
                    : state.dcPageIndex,
            };
        case "SET_DC_CONTACT_ERROR":
            return {
                ...state,
                dcError: typeof action.payload === "boolean" ? action.payload : state.dcError,
            };
        // For Quatation Contacts    
        case "QC_CONTACT_LOADING":
            return {
                ...state,
                qcLoading: typeof action.payload === "boolean" ? action.payload : state.qcLoading,
            };
        case 'SET_QUATATION_CONTACT_DATA':
            return {
                ...state,
                quotationContact: Array.isArray(action.payload)
                    ? action.payload
                    : state.quotationContact,
            };

        case 'APPEND_QUATATION_CONTACT_DATA':
            const existingIdsQC = new Set(state.quotationContact.map(p => p.id));
            const newUniqueQC = action.payload.filter(p => !existingIdsQC.has(p.id));

            return {
                ...state,
                quotationContact: [...state.quotationContact, ...newUniqueQC],
            };
        case 'QC_SUMMARY':
            return {
                ...state,
                qcSummary: action.payload && typeof action.payload === 'object'
                    ? action.payload
                    : state.qcSummary,
            };

        case 'QC_PAGE_INDEX':
            return {
                ...state,
                qcPageIndex: typeof action.payload === 'number' && !isNaN(action.payload)
                    ? action.payload
                    : state.qcPageIndex,
            };
        case "SET_QC_CONTACT_ERROR":
            return {
                ...state,
                qcPageIndexcError: typeof action.payload === "boolean" ? action.payload : state.qcPageIndexcError,
            };
        //QC Active User Messages   
        case "SET_ACTIVE_USER":
            return {
                ...state,
                activeUser: action.payload && typeof action.payload === 'object'
                    ? action.payload
                    : state.activeUser,
            };

        case "MSG_LOADING":
            return {
                ...state,
                msgLoading: typeof action.payload === "boolean" ? action.payload : state.msgLoading,
            };
        case 'SET_MESSAGES_DATA':
            return {
                ...state,
                msg: Array.isArray(action.payload)
                    ? action.payload
                    : state.msg,
            };

        case 'APPEND_MESSAGE_TOP':
            return {
                ...state,
                msg: [...action.payload, ...state.msg],
            };

        case 'MESSAGE_SUMMARY':
            return {
                ...state,
                msgSummary: action.payload && typeof action.payload === 'object'
                    ? action.payload
                    : state.msgSummary,
            };

        case 'MESSAGE_PAGE_INDEX':
            return {
                ...state,
                msgPageIndex: typeof action.payload === 'number' && !isNaN(action.payload)
                    ? action.payload
                    : state.msgPageIndex,
            };
        case 'MESSAGE_INITIAL_PAGE_INDEX':
            return {
                ...state,
                initialPageIndex: typeof action.payload === 'number' && !isNaN(action.payload)
                    ? action.payload
                    : state.initialPageIndex,
            };
        case "NEW_MSG_ADDED":
            return {
                ...state,
                newMessageAdded: typeof action.payload === "boolean" ? action.payload : state.newMessageAdded,
            };
        case "ONE_MSG_ADDED":
            return {
                ...state,
                oneMessageAdded: typeof action.payload === "boolean" ? action.payload : state.oneMessageAdded,
            };
        case "SET_MESSAGE_ERROR":
            return {
                ...state,
                msgError: typeof action.payload === "boolean" ? action.payload : state.msgError,
            };
        case "QUOTATION_FORM_TOGGLE":
            return {
                ...state,
                quotationFormToggle: typeof action.payload === "boolean" ? action.payload : state.quotationFormToggle,
            };
        case 'SET_OPERATOR_PARK_OPTIONS_CHAT_DATA':
            return {
                ...state,
                operatorParksOptions: Array.isArray(action.payload)
                    ? action.payload
                    : state.operatorParksOptions,
            };
        case 'UPDATE_QUOTATION_FORM_DATA':
            return {
                ...state,
                formData: {
                    ...state.formData,
                    ...(action.payload && typeof action.payload === 'object' ? action.payload : {}),
                },
            };
        case 'UPDATE_QUOTATION_ERRORS_DATA':
            return {
                ...state,
                errors: {
                    ...state.errors,
                    ...(action.payload && typeof action.payload === 'object' ? action.payload : {}),
                },
            };
        case 'RESET_QUOTATION_FORM':
            return {
                ...state,
                formData: initialDataQuotation,
                errors: initialErrorsQuotation,
            };
        case "TOGGLE_CHAT_CONTACT":
            return {
                ...state,
                toggleChatContact: typeof action.payload === "boolean" ? action.payload : state.toggleChatContact,
            };

        default:
            return state;
    }
};


